module.exports = __webpack_public_path__ + "static/ayeshak-750d382f3d2ffcc7d9ab0afee59a49b2.jpeg";